// gift-note-card.js — gift-note-card init, extracted from the snippet's inline
// <script> so window._gnc_init is defined on initial page load even when no
// gnc block is rendered yet (cart page: the gnc UI only appears AFTER wrapping
// is added via a Shopify section re-render, and innerHTML-injected scripts do
// not execute — so the inline copy never ran and _gnc_init stayed undefined,
// leaving the gift-note checkbox/editor dead). Loaded via <script src> on the
// cart (unconditionally) and the customizers. lastSent now reads the textarea
// value from the DOM instead of a Liquid {{ _initial_note }} injection so the
// file is render-context-independent.

  (function(){
    // The component may be referenced by both a page customizer and the
    // globally available mini cart. One controller is enough; fresh blocks
    // are picked up through the exposed idempotent _gnc_init() function.
    if (window.__giftNoteCardControllerLoaded) {
      if (window._gnc_init) window._gnc_init();
      return;
    }
    window.__giftNoteCardControllerLoaded = true;

    // One per cart-row editor: flushes its pending note and returns a promise
    // for its line writes, or null when it has nothing in flight.
    var pendingFlushers = [];
    // A line write is fetch(/cart.js) then fetch(/cart/change.js). Tapping
    // Checkout right after typing blurs the textarea and starts one, but the
    // navigation aborts it before the change goes out. Hold the click until
    // the writes land (capped), then let it through. On window so it runs
    // before the document-level checkout beacon, which then fires once.
    window.addEventListener('click', function(e){
      var btn = e.target && e.target.closest && e.target.closest('button[name="checkout"]');
      if (!btn || btn.__gncRelease) return;
      var waits = pendingFlushers.map(function(f){ return f(); }).filter(Boolean);
      if (!waits.length) return;
      e.preventDefault();
      e.stopPropagation();
      var done = false;
      function release(){
        if (done) return;
        done = true;
        btn.__gncRelease = true;
        btn.click();
        btn.__gncRelease = false;
      }
      Promise.all(waits).then(release, release);
      setTimeout(release, 4000);
    }, true);

    function init(){
      var groups = {};
      // Only pick elements that haven't already been wired up — repeated
      // calls (after a Shopify section re-render that brings fresh DOM)
      // skip the already-inited groups without double-binding events.
      document.querySelectorAll('.gnc[data-gnc]:not([data-gnc-inited])').forEach(function(el){
        var id = el.getAttribute('data-gnc');
        (groups[id] = groups[id] || []).push(el);
      });
      if (Object.keys(groups).length === 0) return;

      Object.keys(groups).forEach(function(id){
        var els = groups[id];
        els.forEach(function(el){ el.setAttribute('data-gnc-inited', '1'); });
        var inputs = [];
        var bodies = [];
        var counts = [];
        var toggles = [];
        var cards = [];
        var max = 250;

        var checkboxes = [];
        var fontToggles = [];
        els.forEach(function(el){
          max = parseInt(el.getAttribute('data-max'), 10) || max;
          el.querySelectorAll('[data-gnc-input]').forEach(function(n){ inputs.push(n); });
          el.querySelectorAll('[data-gnc-body]').forEach(function(n){ bodies.push(n); });
          el.querySelectorAll('[data-gnc-count]').forEach(function(n){ counts.push(n); });
          el.querySelectorAll('[data-gnc-design]').forEach(function(n){ toggles.push({btn: n, root: el}); });
          el.querySelectorAll('[data-gnc-font]').forEach(function(n){ fontToggles.push({btn: n, root: el}); });
          el.querySelectorAll('[data-gnc-card]').forEach(function(n){ cards.push(n); });
          el.querySelectorAll('[data-gnc-enabled]').forEach(function(n){ checkboxes.push(n); });
        });

        // All interior typography is em-based, so to scale the whole card we
        // only need to adjust its own font-size. Reference width = 260px (the
        // self-contained scene card). Overlay cards measure smaller and get a
        // smaller base font; the cart-scene card stays at the original size.
        var BASE_WIDTH = 260;
        var BASE_FS = 16;
        function updateCardScales(){
          cards.forEach(function(card){
            var w = card.offsetWidth;
            if (!w) return;
            card.style.fontSize = Math.max(8, BASE_FS * (w / BASE_WIDTH)) + 'px';
          });
        }

        // Starting em-multiplier per message length. Picked so a typical
        // single-line greeting (~20-30 chars in a script font) fits on one
        // line without wrapping at the small overlay-card size. fitToBox()
        // shrinks further if the rendered text actually overflows.
        function startEm(text, isMin){
          var len = text.length;
          var t;
          if (len <= 60)       t = [1.25, 1.0];
          else if (len <= 120) t = [1.05, 0.9];
          else if (len <= 180) t = [0.92, 0.82];
          else                 t = [0.82, 0.74];
          return isMin ? t[0] : t[1];
        }

        function fitToBox(span){
          var box = span.parentElement;
          if (!box) return;
          var cur = parseFloat(span.style.fontSize) || 1.375;
          var steps = 0;
          // Shrink until content fits both vertically and horizontally.
          while (steps < 24 &&
                 (span.scrollHeight > box.clientHeight ||
                  span.scrollWidth  > box.clientWidth) &&
                 cur > 0.55) {
            cur = Math.max(0.55, cur - 0.06);
            span.style.fontSize = cur.toFixed(2) + 'em';
            steps++;
          }
        }

        function render(){
          var v = (inputs[0] && inputs[0].value) || '';
          bodies.forEach(function(span){
            var isMin = span.parentElement &&
                        span.parentElement.classList.contains('gnc-body--min');
            if (!v.trim()) {
              span.textContent = isMin
                ? 'With all my love. — you'
                : 'Your message will appear here…';
              span.setAttribute('data-empty', 'true');
            } else {
              span.textContent = v;
              span.removeAttribute('data-empty');
            }
            span.style.fontSize = startEm(v, isMin) + 'em';
            // Defer the fit pass so layout has the current text first.
            requestAnimationFrame(function(){ fitToBox(span); });
          });
          counts.forEach(function(c){ c.textContent = v.length; });
        }

        // Debounced sync. Two modes:
        //   - line-property mode (data-line-key set): merge with existing
        //     line-item properties (we GET /cart.js, then POST /cart/change.js
        //     with the merged props dict)
        //   - cart-attribute mode (legacy, default): POST /cart/update.js
        //     setting attributes._addon_gift_note
        //
        // Both dedupe against `lastSent` and use keepalive so a flush
        // kicked off mid-navigation (ATC, page-hide) still completes.
        var lineKey = (els[0] && els[0].getAttribute('data-line-key')) || '';
        var localOnly = !!(els[0] && els[0].getAttribute('data-local-only') === 'true');
        var syncTimer = null;
        var lastSent = (inputs[0] ? inputs[0].value : '') || '';
        var lineQueue = Promise.resolve();
        var lineWrites = 0;

        function isEnabled(){
          return !!(els[0] && els[0].getAttribute('data-enabled') === 'true');
        }

        function postNoteCartAttr(v){
          if (localOnly) return;
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { _addon_gift_note: v } }),
            keepalive: true
          });
        }

        // A Shopify line key is variantId:propertiesHash, so the wrap line's
        // key changes on every property write. Caching the key from page
        // load made every save after the first find no line and silently do
        // nothing (a customer pausing mid-message kept only the first part).
        // Resolve the line fresh through cart-line-addons' pairing lookup,
        // falling back to the last key seen.
        function findLine(cart){
          var li = null;
          try { if (window._clnPairedGiftLine) li = window._clnPairedGiftLine(els[0], cart); } catch(_){}
          return li || (cart.items || []).filter(function(x){ return x.key === lineKey; })[0] || null;
        }
        // Writes run one at a time: each reads the line's current properties,
        // so overlapping writes would put back what the other just changed.
        function writeLineProps(edit){
          lineWrites++;
          lineQueue = lineQueue.then(function(){
            return fetch('/cart.js')
              .then(function(r){ return r.json(); })
              .then(function(cart){
                var li = findLine(cart);
                if (!li) return;
                var props = edit(Object.assign({}, li.properties || {}));
                return fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: li.key, properties: props }),
                  keepalive: true
                }).then(function(r){ return r.json(); }).then(function(next){
                  var fresh = next && next.items && findLine(next);
                  if (!fresh) return;
                  lineKey = fresh.key;
                  els.forEach(function(el){ el.setAttribute('data-line-key', fresh.key); });
                });
              });
          }).catch(function(){}).then(function(){ lineWrites--; });
          return lineQueue;
        }
        function postNoteLineProp(v){
          writeLineProps(function(props){
            if (v.trim()) {
              props._gift_note = v;
              var design = els[0] && els[0].getAttribute('data-design');
              if (design) props._gift_card_design = design;
              var font = els[0] && els[0].getAttribute('data-font');
              if (font) props._gift_card_font = font;
            } else {
              delete props._gift_note;
            }
            return props;
          });
        }
        function postNote(value){
          // An unticked box keeps its text for re-ticking, but must never
          // save it: a blur or button tap after unticking used to put the
          // message back on the order.
          var v = isEnabled() ? (value || '') : '';
          if (v === lastSent) return;
          lastSent = v;
          try {
            if (lineKey) postNoteLineProp(v); else postNoteCartAttr(v);
          } catch(_){}
        }
        function syncNoteToCart(value){
          clearTimeout(syncTimer);
          syncTimer = setTimeout(function(){ postNote(value); }, 700);
        }
        function flushNoteSync(){
          if (!inputs[0]) return;
          clearTimeout(syncTimer);
          postNote(inputs[0].value);
        }
        if (lineKey && !localOnly) {
          pendingFlushers.push(function(){
            // A re-rendered cart drops this editor; it has nothing to hold.
            if (!els[0] || !els[0].isConnected) return null;
            flushNoteSync();
            return lineWrites ? lineQueue : null;
          });
        }

        inputs.forEach(function(inp){
          inp.addEventListener('input', function(){
            inputs.forEach(function(other){ if (other !== inp) other.value = inp.value; });
            render();
            syncNoteToCart(inp.value);
          });
          // Blur flushes immediately (deduped — no-op if unchanged).
          inp.addEventListener('blur', flushNoteSync);
        });

        // ATC click — last-resort flush in case blur didn't fire (some
        // browsers don't blur when a button is tapped from a touch).
        // Deduped so it costs nothing if blur already covered it.
        document.addEventListener('click', function(e){
          var btn = e.target && e.target.closest && e.target.closest('button, [type="submit"]');
          if (!btn) return;
          var id = (btn.id || '').toLowerCase();
          var name = (btn.getAttribute && (btn.getAttribute('name') || '')).toLowerCase();
          if (id.indexOf('add-to-cart') >= 0 || id === 'sm2-add-to-cart' || name === 'add') {
            flushNoteSync();
          }
        }, true);

        // Persist a single gift-card property. Three modes:
        //  - localOnly  → no sync (customizer reads the DOM at ATC time)
        //  - lineKey    → merge onto the paired line item's properties
        //  - otherwise  → legacy cart-attribute write
        function syncCardProp(key, value){
          if (localOnly) return;
          try {
            if (lineKey) {
              writeLineProps(function(props){ props[key] = value; return props; });
            } else {
              var attrs = {};
              attrs[key] = value;
              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: attrs }),
                keepalive: true
              });
            }
          } catch(_){}
        }

        // Dedupe against the LIVE attribute, not a cached var — the
        // localStorage restore below mutates data-design / data-font
        // after init, so a cached "last" value would go stale and make
        // the genuinely-unselected button look unclickable.
        function setDesign(design){
          if (design === (els[0] && els[0].getAttribute('data-design'))) return;
          els.forEach(function(el){ el.setAttribute('data-design', design); });
          syncCardProp('_gift_card_design', design);
          try { localStorage.setItem('skylit_gnc_design', design); } catch(_){}
        }

        toggles.forEach(function(t){
          t.btn.addEventListener('click', function(){
            setDesign(t.btn.getAttribute('data-gnc-design'));
          });
        });

        function setFont(font){
          if (font !== 'handwritten' && font !== 'classic') return;
          if (font === (els[0] && els[0].getAttribute('data-font'))) return;
          els.forEach(function(el){ el.setAttribute('data-font', font); });
          syncCardProp('_gift_card_font', font);
          try { localStorage.setItem('skylit_gnc_font', font); } catch(_){}
          // Re-fit the message — Sacramento and Josefin Sans have very
          // different metrics, so a string that fit one may overflow the
          // other. render() resets the start size, then fitToBox shrinks.
          render();
        }
        fontToggles.forEach(function(t){
          t.btn.addEventListener('click', function(){
            setFont(t.btn.getAttribute('data-gnc-font'));
          });
        });

        try {
          var saved = localStorage.getItem('skylit_gnc_design');
          if (saved === 'editorial' || saved === 'minimal') {
            els.forEach(function(el){ el.setAttribute('data-design', saved); });
          }
          var savedFont = localStorage.getItem('skylit_gnc_font');
          if (savedFont === 'handwritten' || savedFont === 'classic') {
            els.forEach(function(el){ el.setAttribute('data-font', savedFont); });
          }
        } catch(_){}

        function setEnabled(on){
          // Dedupe against the live DOM, not a closure copy: the customizer
          // hosts (starmap-v2.js draft/paired-addon hydrators) write
          // data-enabled directly, and a stale closure here swallowed the
          // customer's first checkbox click after such a write.
          var cur = els[0] && els[0].getAttribute('data-enabled') === 'true';
          if (on === cur) return;
          var v = on ? 'true' : 'false';
          els.forEach(function(el){ el.setAttribute('data-enabled', v); });
          checkboxes.forEach(function(cb){ cb.checked = on; });
          // Turning OFF takes the message off the order so it can't print if
          // the customer decides against it. The textarea keeps its text so
          // re-ticking restores it.
          if (lineKey) {
            // Line mode: the message lives on the wrap line, so that is what
            // has to change. The cart-level flag below is legacy-mode only
            // (it was left set on orders whose wrap was later removed).
            if (!on && !localOnly) {
              clearTimeout(syncTimer);
              lastSent = '';
              writeLineProps(function(props){ delete props._gift_note; return props; });
            }
          } else {
            var attrs = { _gift_card_enabled: on ? '1' : '' };
            if (!on) { attrs._addon_gift_note = ''; lastSent = ''; }
            if (!localOnly) {
              try {
                fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ attributes: attrs }),
                  keepalive: true
                });
              } catch(_){}
            }
          }
          // If turning back on with non-empty text, push it straight back.
          if (on && inputs[0] && inputs[0].value) {
            flushNoteSync();
          }
          // The card may have been display:none — re-measure scales now
          // that it's visible (or hidden) again.
          requestAnimationFrame(function(){ updateCardScales(); render(); });
        }
        checkboxes.forEach(function(cb){
          cb.addEventListener('change', function(e){
            // Stop the change bubbling to the theme's <cart-items> element,
            // whose delegated change listener treats ANY input change as a line
            // quantity update and posts /cart/change with quantity = this
            // checkbox's value ("on") → 400 "expected String to be a Integer".
            if (e && e.stopPropagation) e.stopPropagation();
            setEnabled(cb.checked);
          });
        });

        // Initial paint, then keep card scales in sync with their container.
        updateCardScales();
        render();
        if (typeof ResizeObserver !== 'undefined' && cards.length) {
          var ro = new ResizeObserver(function(){ updateCardScales(); });
          cards.forEach(function(c){ ro.observe(c); });
        }
        window.addEventListener('resize', updateCardScales);
      });
    }

    // Expose so cart-line-addons can re-init this snippet after Shopify
    // section re-render swaps in fresh DOM (scripts inside replaced HTML
    // don't auto-execute).
    window._gnc_init = init;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
